import React from 'react';
import type { CalculationConfig } from '../core/ScheduleDataContext';

export interface CalculationContextProps {
  calculationConfig: CalculationConfig | null;
}

export const CalculationContext = React.createContext<CalculationContextProps>({
  calculationConfig: null,
});

export default CalculationContext;
